<script setup>
const user = useUser()

const techs = ref([
  { id: 'laravel', label: 'Laravel' },
  { id: 'react', label: 'React' },
  { id: 'typescript', label: 'TypeScript' },
  { id: 'javascript', label: 'JavaScript' },
  { id: 'wordpress', label: 'WordPress' },
  { id: 'angular', label: 'Angular' },
  { id: 'pinia', label: 'Pinia' },
  { id: 'next', label: 'Next.js' },
  { id: 'tailwind', label: 'Tailwind' },
  { id: 'vuejs', label: 'Vue.js' },
  { id: 'nuxt', label: 'Nuxt' }
])

const votes = computed(() => user.data?.metadata?.interest || [])
</script>

<template>
  <AppContainer
    id="cast-your-vote"
    class="pt-32 md:pt-40">
    <h2 class="heading-primary mx-auto max-w-xl text-center text-3xl font-bold md:text-[54px] md:leading-tight xl:max-w-full">
      Have your say!
      <br>
      What <em>Certifications</em> do you want?
    </h2>

    <p class="mx-auto mt-10 max-w-lg text-center text-sm font-light text-eerie-black md:mt-15 md:text-lg dark:text-white">
      Let us know which ones you’d like to receive validation
      for your skills by voting in the poll:
    </p>

    <div
      class="mx-auto mt-10 grid max-w-xl gap-6 md:mt-15 md:gap-10 xl:max-w-full">
      <div class="grid gap-5 xl:grid-cols-2">
        <HomePollTech
          v-for="tech in techs"
          :key="tech.id"
          v-bind="{ tech, votes }" />
        <HomePollFreeText />
      </div>

      <div class="flex h-40 flex-col items-center justify-center gap-6">
        <p class="mx-auto max-w-2xl text-center text-sm font-light text-eerie-black md:text-lg dark:text-body-gray">
          Log your votes and we will keep you updated with progress on securing your selected certification options.
        </p>

        <div
          v-if="user.submittingVotes.length"
          class="flex items-center gap-2">
          <AppLoading />
          <span class="text-xl font-bold">
            Submitting your vote...
          </span>
        </div>

        <div
          v-else-if="votes.length"
          class="heading-primary text-xl font-bold">
          <em>Thank you for your vote{{ votes.length > 1 ? 's' : '' }}!</em>
        </div>
      </div>
    </div>
  </AppContainer>
</template>
